module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "提现转账信息",
      "visible": _vm.formVisible,
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("方式：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.infos.fs == 'geren') ? _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("个人")]) : (_vm.infos.fs == 'qiye') ? _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("企业")]) : _c('el-tag', [_vm._v("支付宝")])], 1)], 1), _vm._v(" "), (_vm.infos.fs == 'geren') ? _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.idname))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("身份号：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.idcard))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行卡：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.banknum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.bankaddr))])], 1)], 1) : (_vm.infos.fs == 'qiye') ? _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.qyname))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("统一信用码：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.qynum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行帐户：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.banknum))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.bankaddr))])], 1)], 1) : _c('div', [_c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("身份号：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.aliid))])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "text item infoItem"
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.infos.aliname))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68d8ab8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/user/txTaxTips.vue
// module id = 1173
// module chunks = 1